import { inject, injectable } from 'inversify';
import type { ICaseDataRepositoryFactory, ICaseDataRepository, RepositoryType } from '../CaseDataProvider';
import type { CaseFilesApi } from '../CaseFilesApi';
import type { CaseInfoApi } from '../CaseInfoApi';
import { NetworkCaseDataRepository } from './NetworkCaseDataRepository';
import { TYPES } from '@/engine/ioc/types';
import type { PackageInfoStore } from './PackageInfoStore';
import { OFFLINE_TYPES } from '../modules/offline';
import type { OfflineDetectionService } from '../modules/offline/services/OfflineDetection.service';
import { OfflineCaseDataRepository } from '../modules/offline/services/OfflineCaseDataRepository';
import type { OfflineDB } from '../modules/offline/services/OfflineDB';

@injectable()
export class CaseDataRepositoryFactory implements ICaseDataRepositoryFactory {
  private _caseInfoApi: CaseInfoApi;

  private _caseFilesApi: CaseFilesApi;

  private _packageInfoStore: PackageInfoStore;

  private _offlineDetectionService: OfflineDetectionService;

  private _offlineDB: OfflineDB;

  public constructor(
    @inject(TYPES.CaseInfoApi) caseInfoApi: CaseInfoApi,
    @inject(TYPES.CaseFilesApi) caseFilesApi: CaseFilesApi,
    @inject(TYPES.PackageInfoStore) packageInfoStore: PackageInfoStore,
    @inject(OFFLINE_TYPES.OfflineDetectionService) offlineDetectionService: OfflineDetectionService,
    @inject(OFFLINE_TYPES.OfflineDB) offlineDB: OfflineDB
  ) {
    this._caseInfoApi = caseInfoApi;
    this._caseFilesApi = caseFilesApi;
    this._packageInfoStore = packageInfoStore;
    this._offlineDetectionService = offlineDetectionService;
    this._offlineDB = offlineDB;
  }

  public create(repositoryType: RepositoryType = 'auto'): ICaseDataRepository {
    let actualRepoType = repositoryType;
    if (repositoryType === 'auto') {
      actualRepoType = this._offlineDetectionService.getOnlineStatus() ? 'network' : 'offline';
    }

    if (actualRepoType === 'network') {
      return new NetworkCaseDataRepository(this._caseInfoApi, this._caseFilesApi, this._packageInfoStore);
    } else {
      return new OfflineCaseDataRepository(this._offlineDB);
    }
  }
}
